<template>
  <div class="layout-center" align="center" justify="center" :style="bgc">
    <!-- <v-card v-if="args.empty" height="100%">
      <v-card-text>
     <p class="text-xs-center">No data available</p>
     </v-card-text>
    </v-card> -->
    <v-container fill-height fluid v-if="args.empty">
      <v-row align="center" justify="center">
        <v-col>No data available</v-col>
      </v-row>
    </v-container>
    <component
      v-else
      v-show="render"
      :is="item.component"
      :args="args"
    ></component>
  </div>
</template>
<script>
import ItemDisplay from "./ItemDisplay";
import ui from "@/../../coreui/helpers/ui";
import { sync } from "vuex-pathify";
export default {
  props: ["item"],
  data: () => ({
    render: false,
  }),
  computed: {
    dark: sync("misc/dark"),
		// fullScreen: sync("misc/fullScreen"),
    args() {
      return this.item.args;
    },
    bgc() {
      return {
        "background-color": ui.theme(this.dark).lighterbg,
        height: "100%",
        width: "100%",
      };
    },
  },
  mounted() {
    var self = this;
    setTimeout(() => {
      self.render = true;
    }, 1000);
  },
};
</script>

<style >
.smartwidget {
  border: 0px !important;
}
.smartwidget .widget-header {
  background-color: lightgray;
  padding-left: 10px;
  font-size: 18px;
}
.smartwidget .widget-header__title {
  color: black;
  font-weight: bold !important;
  font-size: 18px !important;
}

.smartwidget .widget-header__subtitle {
  color: black;
  font-size: 14px !important;
}

.smartwidget .widget-header .widget-header__toolbar {
  color: green !important;
}

.layoutJSON {
  background: #dd0;
  border: 3px solid black;
  /* margin-top: 10px; */
  /* padding: 10px; */
}
.eventsJSON {
  background: #ddd;
  border: 3px solid black;
  /* margin-top: 10px; */
  /* padding: 10px; */
  /* height: 100px; */
  overflow-y: scroll;
  overflow-x: scroll;
}

.columns {
  -moz-columns: 120px;
  -webkit-columns: 120px;
  columns: 120px;
}
.vue-resizable-handle {
  z-index: 5000;
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=");
  background-position: bottom right;
  padding: 0 3px 3px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  box-sizing: border-box;
  cursor: se-resize;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
  /* border: 1px solid black; */
}

.vue-grid-item.resizing {
  opacity: 0.9;
}

.vue-grid-item.static {
  background: #cce;
}

.vue-grid-item .text {
  /* font-size: 24px; */
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  /* height: 24px; */
}

.vue-grid-item .minMax {
  /* font-size: 12px; */
}

.widget-body__content {
  padding: 0px !important;
  height: 100% !important;
}

.layout-center {
  height: 100% !important;
}
.vue-grid-item .add {
  cursor: pointer;
}
</style>

